import React from 'react';
import { Pagination } from 'antd';

/*
  PAGINATION MOBILE DÉDUITE (lot 3).

  POURQUOI CE MODULE EXISTE
  NdoeResponsiveTable ignorait `pagination` sur mobile : il ne rendait que
  `mobilePager`, écrit à la main par 8 pages seulement. Une page migrée sans y
  penser affichait donc sa PREMIÈRE PAGE et rien d'autre — aucun bouton, aucun
  indice qu'il manquait des lignes. Sur une pagination serveur (JournalStock :
  25 lignes par page sur l'ensemble du stock), c'est une troncature silencieuse
  des données : pire qu'un tableau large, qui au moins ne ment pas.

  C'était la seconde barrière à la migration, après `renderCard` obligatoire.
  Ici aussi on retourne la charge : la pagination mobile se déduit de l'objet
  `pagination` déjà passé au tableau desktop.

  On rebranche sur le `onChange` de la page en respectant la signature antd
  Table — (paginationConfig, filters, sorter) — pour que le handler existant
  fonctionne sans être touché. `pagination.onChange`, quand la page en définit
  un, garde la priorité.

  CE QU'ON GARDE, CE QU'ON LAISSE
  - `showTotal` est repris : c'est le « 1 523 opération(s) » qui dit à
    l'utilisateur combien il y a de lignes en tout. Il s'affiche même sur une
    seule page — sinon une liste courte n'aurait plus aucun compteur, alors que
    le tableau brut d'avant en montrait un.
  - `showSizeChanger` est abandonné : choisir « 200 par page » au pouce sur une
    liste de cartes n'aide personne, et le sélecteur déborde sous 360px.
  - `showQuickJumper` est abandonné : saisir un numéro de page ouvre le clavier
    pour un gain nul face aux flèches.
*/
export default function PagerMobile({ pagination, onChange }) {
  if (!pagination || pagination === false) return null;

  const { current = 1, pageSize = 10, total = 0 } = pagination;
  const plusieursPages = total > pageSize;
  if (!total) return null;

  // antd Table appelle les DEUX callbacks quand on change de page : on fait
  // pareil. Les traiter comme exclusifs casserait une page qui met son état
  // local dans `pagination.onChange` et son rechargement serveur dans
  // `onChange` — le pager avancerait sans que la liste change.
  const aller = (page, taille) => {
    if (typeof pagination.onChange === 'function') pagination.onChange(page, taille);
    if (typeof onChange === 'function') {
      onChange({ ...pagination, current: page, pageSize: taille }, {}, {});
    }
  };

  const total_ = Number(total) || 0;
  const debut = (current - 1) * pageSize;
  const legende =
    typeof pagination.showTotal === 'function'
      ? pagination.showTotal(total_, [debut + 1, Math.min(debut + pageSize, total_)])
      : null;

  return (
    <div className="ndoe-pager-mobile">
      {legende ? <div className="ndoe-pager-mobile__total">{legende}</div> : null}
      {plusieursPages ? (
        <Pagination
          size="small"
          current={current}
          pageSize={pageSize}
          total={total_}
          showSizeChanger={false}
          showLessItems
          onChange={aller}
        />
      ) : null}
    </div>
  );
}
